import { memo } from 'react';
import { IconProps } from './iconType';

export const ListIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
      <path
        d="M5 4V8H17V4H19.007C19.2703 4.00026 19.5227 4.10497 19.7089 4.29114C19.895 4.4773 19.9997 4.72972 20 4.993V21.007C19.9997 21.2703 19.895 21.5227 19.7089 21.7089C19.5227 21.895 19.2703 21.9997 19.007 22H2.993C2.72964 22 2.47707 21.8954 2.29084 21.7092C2.10462 21.5229 2 21.2704 2 21.007V4.993C2.00026 4.72972 2.10497 4.4773 2.29114 4.29114C2.4773 4.10497 2.72972 4.00026 2.993 4H5ZM8 17H6V19H8V17ZM8 14H6V16H8V14ZM8 11H6V13H8V11ZM15 2V6H7V2H15Z"
        fill={color}
      />
    </svg>
  );
});

ListIcon.displayName = 'ListIcon';
